export default __webpack_public_path__ + "static/media/Acolyte's Hood of the Underworld.71f4adaa.jpg";